import { Component, EventEmitter, OnInit, Output } from '@angular/core';



@Component({
  selector: 'app-botao-flutuante-voltar-cards',
  templateUrl: './botao-flutuante-voltar-cards.component.html',
  styleUrls: ['./botao-flutuante-voltar-cards.component.css']
})
export class BotaoFlutuanteVoltarCardsComponent implements OnInit {

  @Output() voltarCard = new EventEmitter();


  constructor() { }

  ngOnInit() { }


  backPage() {
    this.voltarCard.emit({valorEscolhido: 0});
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/layout/botao-flutuante-voltar-cards/botao-flutuante-voltar-cards.component.ts